import { render, staticRenderFns } from "./VatInput.vue?vue&type=template&id=5bdad4e8&"
import script from "./VatInput.vue?vue&type=script&lang=js&"
export * from "./VatInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports